<template>
    <v-container>
        <h3 class="mb-5">สถานะการตอบแบบประเมินหัวหน้าส่วนงาน</h3>

        <ProgressTable :items="items" title="ชื่อแบบประเมิน" :showButton="true" @row-click="onRowClick" :loading="loading"></ProgressTable>

        <v-dialog v-model="showAssessmentProgress" scrollable width="1000">
            <v-card>
                <v-card-title>{{ assessment.title }}</v-card-title>
                <v-card-text class="pa-0">
                    <ProgressTable :items="assessmentItems" title="ชื่อผู้รับการประเมิน" :showButton="true"  :loading="loading" @row-click="onAssessmentRowClick">
                    </ProgressTable>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="showAssessmentProgress = false">ปิด</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showAssesseeProgress" scrollable width="1000">
            <v-card>
                <v-card-title>{{ assessment.title }} - {{ assessee.title }}</v-card-title>
                <v-card-text class="pa-0">
                    <ProgressTable :items="assesseeItems" title="ชื่อกลุ่มผู้ประเมิน"  :loading="loading">
                    </ProgressTable>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="showAssesseeProgress = false">ปิด</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import server from "../../../../services/server"
import ProgressTable from "../../components/ProgressTable.vue";

export default {
    name: "AssessmentReportProgress",

    components: { ProgressTable },

    data() {
        return {
            items: [],
            assessment: {},
            assessmentItems: [],
            showAssessmentProgress: false,
            assessee: {},
            assesseeItems: [],
            showAssesseeProgress: false,
            loading: false,
        }
    },

    async mounted() {
        this.loading=true

        const facultyId = this.$route.params.id
        this.items = await server.get('report/assessment_progress_faculty/' + facultyId)

        this.caclulate(this.items)
        this.loading=false
    },

    methods: {
        caclulate(items) {
            if (items) {
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];

                    if (item.noOfAssessors) {
                        item.percent = item.percent = item.progress / item.noOfAssessors * 100
                    }
                    else {
                        item.percent = 0
                    }
                }
            }
        },
        async onRowClick(e) {
            this.showAssessmentProgress = true
            this.assessment = e

            const assessmentId = e.id
            this.assessmentItems = await server.get('report/assessment_progress_id/' + assessmentId)

            this.caclulate(this.assessmentItems)
        },
        async onAssessmentRowClick(e) {
            this.showAssesseeProgress = true
            this.assessee = e

            const assesseeId = e.id
            this.assesseeItems = await server.get('report/assessment_progress_assessee/' + assesseeId)

            this.caclulate(this.assesseeItems)
        }
    }
}
</script>
